import React from 'react';
import styled from 'styled-components';

export type AiConversationStarter = (
  sendMessage: (prompt: string, sendPrompt?: boolean) => void,
  attachFile: () => void,
  sketch: () => void,
) => React.ReactNode;

export const AiChatStarterBubblesContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  gap: 1.2rem;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;
  overflow: scroll;

  padding: 1rem;
  margin: -1rem;
`;

export const AiChatStarterBubble = styled.div`
  display: block;
  padding: 1.4rem 1.8rem;
  border-radius: 2rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0),
    0 3px 4px 0 rgba(151, 210, 206, 0.22), 0 0.5px 0.5px 0 rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 0.8);
  font-size: 1.3rem;
  font-family: Inter, sans-serif;
  letter-spacing: -0.17px;
  color: #63707c;
  cursor: pointer;
  user-select: none;

  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1),
      0 3px 4px 0 rgba(151, 210, 206, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.15);
    background-color: rgba(255, 255, 255, 1);
    color: #444f60;
    transform: translateY(-2px);
  }

  &:active {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px 0 rgba(151, 210, 206, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.15);
    transform: translateY(0);
  }
`;
